import {
    get,
    isEqual
} from 'lodash';
import {
    SEARCH_ALL_CLEAR,
    SEARCH_ALL_FAILURE,
    SEARCH_ALL_LOAD,
    SEARCH_ALL_SUCCESS
} from './searchActions';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case SEARCH_ALL_CLEAR:
            newState = {
                ...state,
                loaded: false,
                loading: false,
                results: {}
            };

            return isEqual(state, newState) ? state : newState;

        case SEARCH_ALL_LOAD:
            newState = {
                ...state,
                loaded: false,
                loading: true,
                results: {}
            };

            return isEqual(state, newState) ? state : newState;

        case SEARCH_ALL_FAILURE:
            newState = {
                ...state,
                error: action.error,
                loaded: false,
                loading: false
            };

            return isEqual(state, newState) ? state : newState;

        case SEARCH_ALL_SUCCESS:
            newState = {
                ...state,
                loaded: true,
                loading: false,
                results: action.results
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getSearchEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'search')
);

export const getIsSearchLoading = createSelector(
    getSearchEntity,
    (entity) => get(entity, 'loading')
);

export const getIsSearchLoaded = createSelector(
    getSearchEntity,
    (entity) => get(entity, 'loaded')
);

export const getSearchError = createSelector(
    getSearchEntity,
    (entity) => get(entity, 'error')
);

export const getSearchErrorMessage = createSelector(
    getSearchError,
    (error) => get(error, 'message')
);

export const getSearchResults = createSelector(
    getSearchEntity,
    (entity) => get(entity, 'results')
);
